import { render } from "./VueModal.vue?vue&type=template&id=1260a789&scoped=true"
import script from "./VueModal.vue?vue&type=script&lang=js"
export * from "./VueModal.vue?vue&type=script&lang=js"

import "./VueModal.vue?vue&type=style&index=0&id=1260a789&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1260a789"]])

export default __exports__